import React from 'react'
import {Navbar, Nav, Container} from 'react-bootstrap'
import {FaShoppingCart, FaRegUserCircle} from "react-icons/fa"
import {Link} from "react-router-dom"
import Sidebar from './Sidebar'
import Logo from '../images/logo.webp'
const NavbarContainer = ({setSearch}) => {
 return <Navbar className=" w-100 " bg="light" expand="lg" sticky="top">
  <Container fluid>
    <Navbar.Brand href="/"><img src={Logo} width="30" height="20" className="pb-1"/><small>VALETAR MARKETPLACE</small></Navbar.Brand>
      <Nav className="flex-row ms-auto fs-4" >
      <Nav.Link ><FaShoppingCart style={{width:"30px", marginLeft:"3px"}}/></Nav.Link>
      <Nav.Link ><Link to="/login"><FaRegUserCircle style={{width:"30px", marginLeft:"3px"}}/></Link></Nav.Link>
      </Nav >
      <Sidebar setSearch={setSearch} />
  </Container>
  
</Navbar>
}

export default NavbarContainer 